// extracted by mini-css-extract-plugin
module.exports = {"main":"TableCells_main__21F3j","list":"TableCells_list__1CQdp","firstItemBold":"TableCells_firstItemBold__1hlaL","link":"TableCells_link__U7nyu"};